import styled, {ThemeProvider} from 'styled-components'
import {lighten, darken} from 'polished'

export default styled.button`
  outline: none;
  border: none;
  display: block;
  border-radius: 30px;
  padding: 15px 40px 15px 50px;
  margin: 70px auto;
  text-decoration: none;
  color: white;
  background: ${props => props.theme.color};
  :hover {
    background: ${props => lighten(0.05, props.theme.color)};
  }
  :active {
    background: ${props => darken(0.05, props.theme.color)};
  }
`



// WEBPACK FOOTER //
// ./src/components/button.js